import { useSnackbar } from 'notistack';
import { Dispatch, useEffect, useState } from 'react';
import { getAllConstructionList } from '../../../../apicalls/construction';
import { TConstructionMinimal, TSelectItem } from '../../../../types/common';
import {
  checkResData,
  formatDatetime,
  getConstructionsSelectBoxData
} from '../../../../utils/common';
import { UseFormReset } from 'react-hook-form';
import { createDailyReportUrl } from '../../../../apicalls/dailyReport';
import { TDailyReportUrlModalForm } from '../../../../types/dailyReport';

export type Props = {
  setIsOpen: Dispatch<boolean>;
  reset: UseFormReset<any>;
  isOpen: boolean;
  constructIdDef?: number;
};

export const useHooks = (props: Props) => {
  const { setIsOpen, reset, isOpen, constructIdDef } = props;

  const submit = (form: TDailyReportUrlModalForm) => {
    createDailyReportUrl(
      form.construct_id.value,
      formatDatetime(new Date(form.expiration_datetime), 'YYYY/MM/DD HH:MM') +
        ':00'
    ).then((resData: any) => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        if (data) {
          setPublishedUrl(data.data.url);
        }
      });
    });
  };

  // 工事選択リスト
  const [constructList, setConstructList] = useState<TSelectItem[]>([]);

  // 発行されたURL
  const [publishedUrl, setPublishedUrl] = useState('');

  // 有効期限の初期値
  // NOTE:環境によってreact-hook-formのresetでセットした値が
  //      getValuesで取れない場合があるためstateを使用
  const [defaultExpirationDate, setDefaultExpirationDate] = useState('');

  // リンクをコピーボタン押下時のハンドラ
  const handleOnClickCopyLink = () => {
    global.navigator.clipboard.writeText(publishedUrl);
  };

  // キャンセル時の処理
  const cancelSubmit = () => {
    setIsOpen(false);
  };

  // snackbar
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (isOpen) {
      // 入力の初期化
      // 工事選択
      reset({
        construct_id: { value: 0, label: '--' }
      });
      // 期限日を一週間後に設定
      const expirationDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
      setDefaultExpirationDate(
        formatDatetime(expirationDate, 'YYYY-MM-DD HH:MM') + ':00'
      );

      setPublishedUrl('');

      // 工事セレクトボックスを取得
      getConstructionsSelectBoxData(setConstructList, enqueueSnackbar, {
        value: 0,
        label: '--'
      });

      // 工事選択リスト設定
      getAllConstructionList().then((resData: any) => {
        checkResData(resData, enqueueSnackbar).then((data: any) => {
          if (data) {
            const resConstructList: TConstructionMinimal[] = data.data;
            if (resConstructList && resConstructList.length > 0) {
              const list: TSelectItem[] = [];
              list.push({ value: 0, label: '--' });
              resConstructList.forEach((construct: TConstructionMinimal) => {
                list.push({
                  value: construct.id,
                  label: construct.name ?? ''
                });
              });

              // 工事IDが渡されている場合は初期表示
              if (constructIdDef) {
                const defaultConstruct = list.find(construct => {
                  return construct.value === constructIdDef;
                });
                if (defaultConstruct) {
                  reset({ construct_id: defaultConstruct });
                }
              }
            }
          }
        });
      });
    }
  }, [isOpen]);

  return {
    submit,
    cancelSubmit,
    constructList,
    publishedUrl,
    handleOnClickCopyLink,
    defaultExpirationDate
  };
};
